import $ from 'jquery';

const AUTOLOOP_INTERVAL: number = 5000; // ms.

function modulo(divisor: number, dividend: number): number {
  return ((divisor % dividend) + dividend) % dividend;
}

$('.js-autoloop').each((index, autoloop) => {
  const $autoloop = $(autoloop);
  const $children = $autoloop.children();

  let currentIndex = 0;

  $children.eq(currentIndex).addClass('is-current');

  if ($children.length <= 1) {
    return;
  }

  function loop() {
    const index = modulo(currentIndex + 1, $children.length);
    $children.removeClass('is-current');
    $children.eq(index).addClass('is-current');
    currentIndex = index;
  }

  setInterval(() => loop(), AUTOLOOP_INTERVAL);
});
